import React, {FC} from 'react';
import {Button} from 'epic-diesel-common';
import themes from 'epic-diesel-common/src/constants/themes';
import root from 'window-or-global';
import Message from '../../../../components/common/Message';
import {BOAPaymentAccountStatus} from '../../../../../shared/types';

//@ts-ignore
import styles from './BOAPayment.pcss';

interface BOABaseProps {
    configState?: any;
    accountStatus: BOAPaymentAccountStatus;
}

const BOAPayment: FC<BOABaseProps> = ({configState, accountStatus}) => {
    const handleClickActiveLink = () => {
        root.open(configState.boaHomePage);
    };

    const buttonCode =
        accountStatus === BOAPaymentAccountStatus.BOA_ACCOUNT_ACTIVATED
            ? 'epic.affiliate.settings.tax.profile.update.boa.v2'
            : 'epic.affiliate.settings.tax.profile.active.boa.v2';

    const disabled =
        accountStatus === BOAPaymentAccountStatus.BOA_ACCOUNT_DISABLED ||
        accountStatus === BOAPaymentAccountStatus.BOA_ACCOUNT_LOCKED ||
        accountStatus === BOAPaymentAccountStatus.BOA_ACCOUNT_PRE_ACTIVATED;

    return (
        <div className={styles.section}>
            <h2>
                <Message code="epic.affiliate.settings.tax.profile.boa.title.v2" />
            </h2>
            <Button
                disabled={disabled}
                theme={themes.DARK}
                onClick={!disabled && handleClickActiveLink}>
                <Message code={buttonCode} />
            </Button>
        </div>
    );
};

export default BOAPayment;
